exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".companies___3vbDI .searchContainer___1bApE{margin:35px 0 53px}", "", {"version":3,"sources":["/./src/containers/Admin/AdminCompany/src/containers/Admin/AdminCompany/src/containers/Admin/AdminCompany/AdminCompany.scss"],"names":[],"mappings":"AAGA,4CAEI,kBAAsB,CACvB","file":"AdminCompany.scss","sourcesContent":["@import '../../../theme/variables.scss';\n@import '../../../theme/mixins.scss';\n\n.companies {\n  .searchContainer {\n    margin: 35px 0 53px 0;\n  }\n}"],"sourceRoot":"webpack://"}]);

// exports
exports.locals = {
	"companies": "companies___3vbDI",
	"searchContainer": "searchContainer___1bApE"
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader?modules&importLoaders=2&sourceMap&localIdentName=[local]___[hash:base64:5]!./~/autoprefixer-loader?browsers=last 2 version!./~/sass-loader?outputStyle=expanded&sourceMap!./src/containers/Admin/AdminCompany/AdminCompany.scss
 ** module id = 556
 ** module chunks = 0
 **/